import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, Button, Divider, Typography } from "@material-ui/core";
import { Add, Replay } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import ResearchProposalInsertModal from "../ResearchProposalInsertModal";
import CheckDuplicateModal from "../../../components/common/CheckDuplicateModal/CheckDuplicateModal";

import { getAllProject } from "../../../reducer/project/action";
import {
  getAllResearchProposal,
  getAllResearchProposalByProfileId,
  getFilteredResearchProposal,
  getDuplicateResearchProposal,
} from "../../../reducer/researchProposal/action";

function ResearchProposalButton(props) {
  const { getAllResearchProposal, getAllResearchProposalByProfileId, getFilteredResearchProposal } = props;

  const [inserting, setInserting] = useState(false);
  const [checking, setChecking] = useState(false);

  let profileId = props.selectedProfileId;
  if (!profileId) profileId = props.profileDetail?.id;

  useEffect(() => {
    if (props.type !== "all" && profileId) getAllResearchProposalByProfileId(profileId);
    return false;
  }, []);

  useEffect(() => {
    if (props.type === "all" && props.listFilteredResearchProposal.length === 0 && !props.isFetching)
      getFilteredResearchProposal(1, -1, { departmentId: props.department });
  }, []);

  useEffect(() => {
    if (props.type === "all" && !props.isFetching && !props.isFetchingAccepted)
      getFilteredResearchProposal(1, -1, { departmentId: props.department });
  }, [props.department, getFilteredResearchProposal]);

  const handleReload = () => {
    if (props.type !== "all") {
      if (profileId) {
        getAllResearchProposalByProfileId(profileId);
        props.handleReload();
      }
    } else {
      getFilteredResearchProposal(1, -1, { departmentId: props.department });
      props.handleReload();
    }
  };
  const handleInsert = () => setInserting(true);
  const handleCheckDuplicate = () => {
    props.getDuplicateResearchProposal();
    setChecking(true);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="h5" style={{ lineHeight: "36px" }}>
            Đề xuất nghiên cứu
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <div style={{ float: "right" }}>
            <Button variant="outlined" startIcon={<Replay />} onClick={handleReload}>
              Tải lại
            </Button>
            {props.type === "all" && props.role === "sudo-admin" && (
              <Button variant="outlined" color="primary" style={{ marginLeft: 8 }} onClick={handleCheckDuplicate}>
                Check trùng
              </Button>
            )}
            {props.type !== "all" && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                style={{ marginLeft: 8 }}
                onClick={handleInsert}
              >
                Thêm
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
      <Divider style={{ margin: "8px 0" }} />
      <ResearchProposalInsertModal inserting={inserting} setInserting={setInserting} />
      <CheckDuplicateModal
        open={checking}
        onClose={() => setChecking(false)}
        loading={props.isCheckingDuplicate}
        data={props.listDuplicate}
        groupKey="duplicateResearchProposal"
        itemKey="researchProposal"
        title="Danh sách đề tài trùng theo tiêu đề"
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  // isFetching: select(state, 'projectReducer', 'isFetching'),
  // isFetchingAccepted: select(state, 'projectReducer', 'isFetchingAccepted'),

  profileDetail: select(state, "profileReducer", "detail"),
  listResearchProposalById: select(state, "researchProposalReducer", "listById"),
  listFilteredResearchProposal: select(state, "researchProposalReducer", "listFiltered"),
  role: select(state, "userReducer", "role"),
  isCheckingDuplicate: select(state, "researchProposalReducer", "isCheckingDuplicate"),
  listDuplicate: select(state, "researchProposalReducer", "listDuplicate"),
});

const mapDispatchToProps = (dispatch) => ({
  getAllResearchProposalByProfileId: (id) => dispatch(getAllResearchProposalByProfileId(id)),
  getFilteredResearchProposal: (page, pageSize, payload) =>
    dispatch(getFilteredResearchProposal(page, pageSize, payload)),
  getDuplicateResearchProposal: () => dispatch(getDuplicateResearchProposal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ResearchProposalButton));

